import React, { Component, createRef } from 'react'
import _ from 'lodash'
import {
  Modal,
  Button,
  Input,
  Spin,
  Row,
  Col,
  Form,
  Icon,
  Progress,
  message
} from 'antd'
import { withTranslation, Trans } from 'react-i18next'
import api from '../../services/api'
import { config, general } from '../../constants'
import { ModalStyles } from './CloneModal.ctrl'
import CourseDropzone from '../../views/Courses/Create/internal/CourseDropzone'
import { EditImageContainer } from '../../components/TextOnImage'
import { PopupMedia } from '../../views/Library/internal'
import { Editor } from '../../components/ImageEditor'
import TranslationSection from './TranslationSection'
import CloningSection from './CloningSection'
import './CloneModal.scss'
import langOptions from './langOptions'

const antIcon = <Icon type="loading" style={{ fontSize: 80 }} spin />

class CloneModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTranslaton: props.isTranslaton,
      isCheckAll: true,
      courseTitle: '',
      isCloning: false,
      courseId: null,
      isMazeClone: false,
      mazeTitle: '',
      mazeId: null,
      isCoverLoading: false,
      modalOpen: false,
      isGenerateAudio: false,
      selectedProvider: 'generate-tts-v2',
      selectedVoiceId: null,
      elevenLabsVoices: [],
      sharelookVoices: [],
      isVoicesLoading: false
    }
    this.imageRef = createRef()
  }

  componentDidMount() {
    const { isTranslaton } = this.state
    if (isTranslaton) {
      this.fetchSharelookVoices()
    }
  }

  fetchElevenLabsVoices = async () => {
    const { elevenLabsVoices, isVoicesLoading } = this.state
    if (isVoicesLoading || elevenLabsVoices.length > 0) return

    this.setState({
      isVoicesLoading: true
    })

    try {
      const response = await api.audioSynthesizer.getElevenLabsVoices()
      const voices =
        response && response.data && Array.isArray(response.data.voices)
          ? response.data.voices
          : []

      this.setState({
        elevenLabsVoices: voices,
        isVoicesLoading: false
      })
    } catch (error) {
      this.setState({
        elevenLabsVoices: [],
        isVoicesLoading: false
      })
      message.error(this.props.t('v4:failed_to_load_elevenlabs_voices'))
    }
  }

  fetchSharelookVoices = async () => {
    const { data } = this.props
    const { sharelookVoices, isVoicesLoading } = this.state
    if (
      isVoicesLoading ||
      sharelookVoices.length > 0 ||
      !data ||
      !data.courseId
    ) {
      return
    }

    this.setState({
      isVoicesLoading: true
    })

    try {
      const response = await api.aiVideoGeneration.listAIVoices(data.courseId)
      const voices = await this.resolveVoicesResponse(response)
      this.setState({
        sharelookVoices: voices,
        isVoicesLoading: false
      })
    } catch (error) {
      this.setState({
        sharelookVoices: [],
        isVoicesLoading: false
      })
      message.error(this.props.t('v4:failed_to_load_elevenlabs_voices'))
    }
  }

  resolveVoicesResponse = async response => {
    const data = response && response.data ? response.data : {}
    const directOutput = data.output || data

    if (
      directOutput &&
      (Array.isArray(directOutput.system_voices) ||
        Array.isArray(directOutput.user_voices))
    ) {
      return this.normalizeSharelookVoices(directOutput)
    }

    const taskId =
      data.task_id || data.taskId || data.id || (data.output && data.output.task_id)
    if (!taskId) return []

    const taskData = await this.pollTaskStatus(taskId)
    const output = taskData && taskData.output ? taskData.output : taskData
    return this.normalizeSharelookVoices(output)
  }

  normalizeSharelookVoices = output => {
    if (!output) return []
    const systemVoices = Array.isArray(output.system_voices)
      ? output.system_voices
      : []
    const userVoices = Array.isArray(output.user_voices) ? output.user_voices : []
    return [...systemVoices, ...userVoices]
      .filter(voice => voice && voice.voice_id)
      .map(voice => ({
        ...voice,
        name: voice.name || voice.description || voice.voice_id
      }))
  }

  pollTaskStatus = async (taskId, delay = 1500, onProgress) => {
    while (true) {
      const statusResponse = await api.aiVideoGeneration.getTaskStatus(taskId)
      const statusData = statusResponse && statusResponse.data
      const statusValue =
        statusData && statusData.status ? String(statusData.status).toLowerCase() : ''
      if (typeof onProgress === 'function') {
        onProgress(statusData)
      }

      if (
        statusValue === 'success' ||
        statusValue === 'completed' ||
        statusValue === 'done'
      ) {
        return statusData
      }

      if (statusValue === 'failed' || statusValue === 'error') {
        throw new Error('Task failed')
      }

      await new Promise(resolve => setTimeout(resolve, delay))
    }
  }

  handleTitle = _.debounce(v => this.handleTitleChange(v), 1000)

  handleTranslateLanguage = language => {
    const { app } = this.props
    app.setState({
      courseCloneLang: language
    })
  }
  handleTitleChange = (v = '') => {
    const { data, app } = this.props

    if (data.type === 'Maze') {
      this.setState({ mazeTitle: v })
      return
    }

    const newTemple = _.cloneDeep(data)

    if (!newTemple) return

    newTemple.courseTitle = v
    app.setState({
      courseCloneTemplate: newTemple
    })
  }

  handleGenerateAudioChange = e => {
    const checked = e.target.checked
    this.setState({
      isGenerateAudio: checked,
      selectedVoiceId: checked ? this.state.selectedVoiceId : null
    })

    if (checked) {
      if (this.state.selectedProvider === 'elevenlabs') {
        this.fetchElevenLabsVoices()
      } else {
        this.fetchSharelookVoices()
      }
    }
  }

  handleProviderChange = provider => {
    this.setState(
      {
        selectedProvider: provider,
        selectedVoiceId: null
      },
      () => {
        if (provider === 'elevenlabs') {
          this.fetchElevenLabsVoices()
        } else {
          this.fetchSharelookVoices()
        }
      }
    )
  }

  handleVoiceChange = voiceId => {
    this.setState({
      selectedVoiceId: voiceId
    })
  }

  getLanguageName = languageCode => {
    const match = langOptions.find(item => item.code === languageCode)
    if (match && match.name) {
      return match.name.toLowerCase()
    }
    return languageCode || ''
  }


  checkFinish = () => {
    const { mazeId } = this.state
    const { data } = this.props
    if (data && data.type === 'Maze') {
      console.log('checkfinishclone', mazeId ? true : false)
      return mazeId ? true : false
    } else {
      const { courseCloningProgress } = this.props
      console.log(
        'checkfinishclone',
        courseCloningProgress && courseCloningProgress.percent === 100
      )
      return courseCloningProgress && courseCloningProgress.percent === 100
    }
  }

  handleCancel = (isHide = false) => {
    const { app, clearCourseCloning } = this.props
    const { courseId } = this.state
    if (courseId && app) {
      clearCourseCloning()
      app.fetchData(true)
    }
    this.setState({
      isCloning: false,
      courseId: null
    })
    if (app) {
      app.setState({
        isClone: false,
        courseCloneTemplate: null
      })
    }
  }

  onDrop = file => {
    const image = URL.createObjectURL(file)
    this.setState({
      file,
      image
    })
  }

  handleClone = () => {
    const { app, clearCourseCloning, data } = this.props
    const { courseId, mazeId, isTranslaton } = this.state

    const isMaze = data && data.type === 'Maze'

    if (isTranslaton && !courseId) {
      this.translateAPI()
    } else if (isMaze && !mazeId) {
      this.cloneMaze()
    } else if (!isMaze && !courseId) {
      this.cloneAPI()
    } else if (courseId) {
      clearCourseCloning()
      if (app) {
        app.props.history.push(`/courses/${courseId}/edit`)
      }
    } else if (mazeId) {
      if (app) {
        app.props.history.push(`/maze/${mazeId}/edit`)
      }
    }
  }

  cloneMaze = () => {
    const {
      data: { id, title }
    } = this.props
    const { mazeTitle, cover } = this.state

    const obj = {
      body: {
        title: mazeTitle || title,
        ...(cover && {
          cover_id: cover.id
        })
      },
      params: {
        programme_id: id
      },
      action: 'clone_programme'
    }

    this.setState({ isCloning: true })

    api.maze.mazeProvider(obj).then(res => {
      if (res) {
        this.setState({ mazeId: res.data.id })
      }
    })
  }

  cloneAPI = () => {
    const {
      data: { courseTitle, courseId, courseLessons },
      app
    } = this.props

    if (courseTitle.length > 0) {
      const customData = {
        title: courseTitle.substring(0, 90),
        lesson_ids: _.map(
          _.filter(courseLessons, lesson => lesson.isChecked),
          item => item.id
        )
      }
      if (app) {
        app.setState({
          courseCloneTemplate: null
        })
      }
      this.setState({
        isCloning: true,
        courseTitle
      })
      api.courses.cloneCourse(courseId, customData).then(({ data }) => {
        this.setState({
          courseId: data.id,
          courseTitle: data.title
        })
      })
    }
  }
  translateAPI = () => {
    const {
      data: { courseTitle, courseId, courseLessons, courseLang },
      clearCourseCloning,
      app
    } = this.props
    const { isGenerateAudio, selectedVoiceId } = this.state
    const selectedLang = app.state.courseCloneLang || courseLang
    const selectedLanguage = this.getLanguageName(selectedLang)

    if (isGenerateAudio && !selectedVoiceId) {
      message.error(this.props.t('v4:voice_must_be_selected'))
      return
    }

    if (courseTitle.length > 0) {
      const customData = {
        title: courseTitle.substring(0, 90),
        isTranslate: true,
        lang: selectedLang,
        language: selectedLanguage,
        isGenerateAudio: !!isGenerateAudio,
        ...(isGenerateAudio &&
          selectedVoiceId && {
          provider: this.state.selectedProvider,
          voice_id: selectedVoiceId
        }),
        lesson_ids: _.map(
          _.filter(courseLessons, lesson => lesson.isChecked),
          item => item.id
        )
      }
      let courseDaa = app.state.courseCloneTemplate
      if (app) {
        app.setState({
          courseCloneTemplate: null
        })
      }

      this.setState({
        isCloning: true,
        courseTitle
      })

      api.courses
        .cloneCourse(courseId, customData)
        .then(({ data }) => {
          this.setState({
            courseId: data.id,
            courseTitle: data.title
          })
        })
        .catch(error => {
          if (app) {
            app.setState({
              courseCloneTemplate: {
                ...courseDaa,
                courseLang: app.state.courseCloneLang
              }
            })
          }
          clearCourseCloning()
          this.setState({
            isCloning: false,
            courseTitle
          })
          let errorMessage = 'Failed to translate, please try again!'

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errorMessage
          ) {
            errorMessage = error.response.data.errorMessage
          } else if (error && error.message) {
            errorMessage = error.message
          }

          message.error(errorMessage)

          this.setState({
            isCloning: false
          })
        })
    }
  }

  handleCheckAll = (recall = false) => {
    if (recall) {
      const { data } = this.props

      const isUnchecked = _.filter(
        data.courseLessons,
        lesson => !lesson.isChecked
      )

      this.setState({
        isCheckAll: _.isEmpty(isUnchecked)
      })
    } else {
      const { isCheckAll } = this.state

      this.setState(
        {
          isCheckAll: !isCheckAll
        },
        () => {
          this.handleCheckGroup(isCheckAll)
        }
      )
    }
  }

  handleCheckOne = ({ id, isChecked }) => {
    const { data, app } = this.props
    const newTemple = _.cloneDeep(data)

    _.map(newTemple.courseLessons, lesson => {
      if (lesson.id === id) {
        lesson.isChecked = !isChecked
      }
    })

    if (app) {
      app.setState(
        {
          courseCloneTemplate: newTemple
        },
        () => {
          this.handleCheckAll(true)
        }
      )
    }
  }

  handleCheckGroup = isCheckAll => {
    const { data, app } = this.props
    const newTemple = _.cloneDeep(data)

    _.map(newTemple.courseLessons, lesson => {
      lesson.isChecked = !isCheckAll
    })
    if (app) {
      app.setState({
        courseCloneTemplate: newTemple
      })
    }
  }

  getCloneBtn = () => {
    const { mazeId, isTranslaton } = this.state
    const { data, courseCloningProgress, t } = this.props
    const isMaze = data && data.type === 'Maze'
    if (isTranslaton) {
      if (courseCloningProgress) {
        const total = courseCloningProgress.total
        const completed = courseCloningProgress.completed
        if (total && completed && total === completed)
          return 'buttons:edit_course'
        else return t('v4:translatingCourse')
      }
      return t('v4:translateModalBtn')
    }
    if (!isMaze) {
      if (courseCloningProgress) {
        const total = courseCloningProgress.total
        const completed = courseCloningProgress.completed
        if (total && completed && total === completed)
          return 'buttons:edit_course'
        else return t('labels:cloning_course')
      }
    }

    if (isMaze && mazeId) {
      return 'v4:edit_maze'
    }
    return 'buttons:clone'
  }

  subTitleString = title => {
    if (title.length > 30) {
      return `${title.substring(0, 30)}...`
    }
    return title
  }

  getPercent = () => {
    const data = this.props.data
    const { mazeId } = this.state
    if (data && data.type === 'Maze') {
      if (mazeId) return 100
      return 0
    } else {
      const { courseCloningProgress } = this.props
      return (
        (courseCloningProgress && courseCloningProgress.percent.toFixed(0)) || 5
      )
    }
  }

  getDisable = (isClone = false) => {
    const { data, courseCloningProgress } = this.props
    const {
      mazeId,
      mazeTitle,
      isCloning,
      isTranslaton,
      isGenerateAudio,
      selectedVoiceId
    } = this.state
    const isMaze = data && data.type === 'Maze'

    if (isClone && isMaze && isCloning && !mazeId) {
      return true
    }

    if (isMaze) {
      if (!mazeTitle) {
        if (data.title) {
          return false
        }
        return true
      }
      return false
    }

    if (!isMaze && data) {
      const isHaveCheck =
        data.courseLessons.filter(item => item.isChecked).length >= 1

      if (isTranslaton && isGenerateAudio && !selectedVoiceId) {
        return true
      }
      return !isHaveCheck
    }

    if (!isMaze && isClone) {
      const total = courseCloningProgress && courseCloningProgress.total
      const completed = courseCloningProgress && courseCloningProgress.completed
      if (total && completed) {
        return total !== completed
      }
      return true
    }

    return this.state.isCloning
  }
  getCancelDisable = (isClone = false) => {
    const { data, courseCloningProgress } = this.props
    const { mazeId, mazeTitle, isCloning } = this.state
    const isMaze = data && data.type === 'Maze'

    if (isClone && isMaze && isCloning && !mazeId) {
      return true
    }

    if (isMaze) {
      if (!mazeTitle) {
        if (data.title) {
          return false
        }
        return true
      }
      return false
    }
    if (!isMaze && isClone) {
      const total = courseCloningProgress && courseCloningProgress.total
      const completed = courseCloningProgress && courseCloningProgress.completed
      if (total && completed) {
        return total !== completed
      }
      return true
    }

    return this.state.isCloning
  }

  getCloseAble = () => {
    const { courseCloningProgress } = this.props
    if (courseCloningProgress) {
      return true
    }
    return false
  }

  handleUploadImage = file => {
    const { upload } = this.props
    this.setState({
      isCoverLoading: true
    })
    return upload(file).then(({ id, link }) => {
      this.setState({
        isCoverLoading: false,
        cover: {
          id: id,
          link: link
        }
      })
    })
  }

  handleClosePopup = type => {
    if (type === general.SAVE) {
      this.setState({
        image: null
      })
    } else {
      this.setState({
        image: null,
        file: null
      })
    }
  }

  hideModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  handleFileUpload = files => {
    if (!files) return
    this.setState({ selectedAudio: files[0] })
  }

  handleInsertData = (privateMedia, publicMedia, orgMedia) => {
    let tempData = []
    if (privateMedia) {
      const { rows: privateData } = privateMedia
      privateData.forEach(data => {
        tempData.push(data)
      })
    }

    if (publicMedia) {
      const { rows: publicData } = publicMedia
      publicData.forEach(publicData => {
        tempData.push(publicData)
      })
    }

    if (orgMedia) {
      const { rows: orgData } = orgMedia
      orgData.forEach(orgData => {
        tempData.push(orgData)
      })
    }

    const selectedItem = _.head(tempData.filter(value => value.isSelected))

    this.setState({
      selectedItem
    })
  }

  hidePreviewModal = () => {
    this.setState({
      selectedItem: null
    })
  }

  handleFileInsert = item => {
    const imageEditorInst = this.imageRef.current.imageEditorInst
    const data = imageEditorInst.toDataURL()
    const body = {
      croppedImage: data,
      lastModifiedDate: new Date(),
      name: item.filename,
      size: item.file_size,
      type: item.media_mime_type
    }
    this.setState(
      {
        modalOpen: false,
        selectedItem: null
      },
      () => {
        this.handleUploadImage(body)
      }
    )
  }

  useCanva = type => {
    var script = document.createElement('script')
    const url = 'https://sdk.canva.com/designbutton/v2/api.js'
    script.src = url
    script.onload = () => {
      if (window.Canva && window.Canva.DesignButton) {
        window.Canva.DesignButton.initialize({
          apiKey: config.canvaKey
        }).then(api => {
          api.createDesign({
            design: {
              type: type
            },
            onDesignPublish: ({ exportUrl, designTitle }) => {
              this.handleImageUrl(exportUrl, designTitle, type)
            }
          })
        })
      }
    }
    document.body.appendChild(script)
  }

  handleImageUrl = async (url, title) => {
    let blob = await fetch(url).then(r => r.blob())
    let data = await new Promise(resolve => {
      let reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    })
    const body = {
      croppedImage: data,
      lastModifiedDate: new Date(),
      name: title,
      size: blob.size,
      type: blob.type
    }
    this.handleUploadImage(body)
  }

  render() {
    const {
      data,
      width,
      visible,
      t,
      form: { getFieldDecorator }
    } = this.props
    const isMaze = data && data.type === 'Maze'

    const {
      isCheckAll,
      courseTitle,
      isCloning,
      mazeTitle,
      selectedItem,
      modalOpen,
      file,
      isCoverLoading,
      image,
      cover,
      isTranslaton,
      isGenerateAudio,
      selectedProvider,
      selectedVoiceId,
      elevenLabsVoices,
      sharelookVoices,
      isVoicesLoading
    } = this.state

    const modalTitle = isTranslaton
      ? t('v4:translateModalTitle')
      : isMaze
        ? 'Clone maze'
        : t('labels:clone_modal')
    const text = isMaze
      ? mazeTitle || (data && data.title)
      : data && data.courseTitle
    const lang = (data && data.courseLang) || 'en'
    if (isMaze) {
      var coverLink = cover
        ? cover.link
        : data && data.cover
          ? data.cover.link
          : ''
    }

    const modal_style = {
      overflow: 'auto',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    }

    const isNoLessonSelected =
      !isMaze &&
      data &&
      data.courseLessons.filter(item => item.isChecked).length < 1
    const isVoiceRequiredMissing =
      isTranslaton && isGenerateAudio && !selectedVoiceId
    const voiceDataSource =
      selectedProvider === 'elevenlabs' ? elevenLabsVoices : sharelookVoices
    const voiceTableData = voiceDataSource
      .filter(voice => voice && voice.voice_id)
      .map(voice => ({
        ...voice,
        key: voice.voice_id
      }))
    const selectedLanguageCode =
      (this.props.app &&
        this.props.app.state &&
        this.props.app.state.courseCloneLang) ||
      lang

    return (
      <Modal
        title={modalTitle}
        width={width}
        className="CloneCourseModal"
        style={ModalStyles}
        centered
        visible={visible}
        footer={null}
        onCancel={() => {
          this.handleCancel(true)
        }}
        closable={this.getCloseAble()}
        maskClosable={false}
      >
        {!data && !isCloning && (
          <div className="cloneloading">
            <Spin indicator={antIcon} />
            <span>Loading...</span>
          </div>
        )}
        {(data || isCloning) && (
          <div className="wrap-content">
            {((!isMaze && data) || (isMaze && !isCloning)) && (
              <div className="modal-section modal-title">
                <span>{t('labels:Title')}</span>
                <Form.Item colon={false} required={false}>
                  {getFieldDecorator('title', {
                    rules: [
                      {
                        required: true,
                        message: t('errors:title_course'),
                        max: 100
                      },
                      {
                        pattern: '.{3,}',
                        message: t('errors:min_3char')
                      }
                    ],
                    initialValue: text
                  })(
                    <Input
                      name="title"
                      maxLength={100}
                      className="title-input"
                      onChange={e => {
                        this.handleTitle(e.target.value)
                      }}
                    />
                  )}
                </Form.Item>
              </div>
            )}
            {isTranslaton && !isCloning && (
              <div className="modal-section">
                <TranslationSection
                  t={t}
                  getFieldDecorator={getFieldDecorator}
                  lang={lang}
                  langOptions={langOptions}
                  onLanguageChange={this.handleTranslateLanguage}
                  isGenerateAudio={isGenerateAudio}
                  onGenerateAudioChange={this.handleGenerateAudioChange}
                  selectedProvider={selectedProvider}
                  onProviderChange={this.handleProviderChange}
                  voiceTableData={voiceTableData}
                  isVoicesLoading={isVoicesLoading}
                  selectedVoiceId={selectedVoiceId}
                  onVoiceSelect={this.handleVoiceChange}
                  selectedLanguageCode={selectedLanguageCode}
                  courseId={data && data.courseId}
                />
              </div>
            )}

            {isMaze && !isCloning && (
              <div className="modal-body">
                <Row>
                  <Col md={24}>
                    <Form.Item
                      colon={false}
                      required={true}
                      label={t('labels:picture')}
                      className="no_bottom_margin"
                    >
                      <CourseDropzone
                        app={this}
                        onDrop={this.onDrop}
                        error={0}
                        disabled={isCoverLoading}
                        cover={coverLink}
                        loadImage={isCoverLoading}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}

            {!isMaze && data && (
              <div className="modal-body modal-section section-lessons">
                <CloningSection
                  t={t}
                  data={data}
                  isCheckAll={isCheckAll}
                  onCheckAll={() => this.handleCheckAll()}
                  onCheckOne={this.handleCheckOne}
                  isNoLessonSelected={isNoLessonSelected}
                  isVoiceRequiredMissing={isVoiceRequiredMissing}
                />
              </div>
            )}

            {isCloning && (
              <div className="cloning-processing">
                <div className="processing-orb">
                  <div className="processing-orb-glow" />
                  <Progress
                    strokeLinecap="round"
                    type="circle"
                    percent={this.getPercent()}
                    size={126}
                    strokeColor="#1f78ff"
                    trailColor="#e9edf4"
                    format={percent => `${percent}%`}
                  />
                </div>
                {!this.checkFinish() && (
                  <div id="title">
                    <Icon type="loading" className="processing-inline-spinner" />
                    <span>
                      {isTranslaton
                        ? t('v4:translatingCourse')
                        : isMaze
                          ? t('v4:cloning_maze')
                          : t('labels:cloning_course')}
                    </span>
                  </div>
                )}
                {!this.checkFinish() && (
                  <span id="desc">
                    {isTranslaton
                      ? t('v4:translationCourseDesc')
                      : t('labels:cloning_course_desc')}
                  </span>
                )}
                {this.checkFinish() && (
                  <span id="title-course">
                    {isTranslaton ? (
                      <Trans i18nKey="v4:translationSuccess">
                        {this.subTitleString(courseTitle)}
                      </Trans>
                    ) : isMaze ? (
                      <Trans i18nKey="v4create_certificate:maze_cloning_success">
                        {this.subTitleString(text)}
                      </Trans>
                    ) : (
                      <Trans i18nKey="labels:cloning_success">
                        {this.subTitleString(courseTitle)}
                      </Trans>
                    )}
                  </span>
                )}
                <div className="wrap_percent">
                  <Progress
                    percent={this.getPercent()}
                    showInfo={false}
                    strokeColor="#1f78ff"
                    trailColor="#e8edf4"
                    strokeWidth={10}
                  />
                </div>
              </div>
            )}

            <div className="modal-footer">
              <Button
                disabled={this.getCancelDisable()}
                className={`btn-cancel ${this.getCancelDisable() &&
                  'disabled'}`}
                onClick={() => this.handleCancel()}
              >
                {t('buttons:cancel')}
              </Button>
              <Button
                disabled={this.getDisable(true)}
                className={`btn-clone ${this.getDisable(true) && 'disabled'}`}
                onClick={() => this.handleClone()}
              >
                {t(`${this.getCloneBtn()}`)}
              </Button>
            </div>
          </div>
        )}

        {image && (
          <EditImageContainer
            image={image}
            handleUploadImage={this.handleUploadImage}
            handleClosePopup={this.handleClosePopup}
            file={file}
          />
        )}

        {modalOpen && (
          <Modal
            visible={modalOpen}
            onCancel={this.hideModal}
            footer={null}
            width={'80%'}
            style={modal_style}
            centered
          >
            <div className="wrap_modal_tabs">
              <PopupMedia
                isPageBuilder
                handleInsertData={this.handleInsertData}
                types="images"
              />
            </div>
            {selectedItem && (
              <Modal
                visible={selectedItem}
                width="70%"
                onCancel={this.hidePreviewModal}
                footer={null}
                centered
              >
                <Editor library={selectedItem} ref={this.imageRef} />

                <div className="wrap_btn_actions">
                  <Button
                    type="danger"
                    size="large"
                    className="action_button"
                    onClick={this.hidePreviewModal}
                  >
                    {general.CANCEL}
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    className="action_button"
                    onClick={() => this.handleFileInsert(selectedItem)}
                  >
                    {general.INSERT}
                  </Button>
                </div>
              </Modal>
            )}
          </Modal>
        )}
      </Modal>
    )
  }
}

export default Form.create()(withTranslation()(CloneModal))
